import * as React from "react";
import { ItemStatus } from "@focus/interfaces/lib/common/itemFetchStatus";
import { Position, Tooltip, Button, Classes, iconClass, IconNames, } from "@focus/focusUI";
function getStatusClass(status) {
    switch (status) {
        case ItemStatus.ERROR:
            return Classes.INTENT_DANGER;
        case ItemStatus.PENDING:
            return Classes.DISABLED;
        default:
            return Classes.INTENT_SUCCESS;
    }
}
function getStatusMessage(status) {
    switch (status) {
        case ItemStatus.ERROR:
            return "Try Again";
        case ItemStatus.PENDING:
            return "Saving";
        default:
            return "Save";
    }
}
export function SaveButton({ onSave, status, locked, validationStatus }) {
    let message = getStatusMessage(status);
    let statusClass = locked ? getStatusClass(status) : Classes.DISABLED;
    let colorClass;
    if (validationStatus === ItemStatus.ERROR) {
        colorClass = Classes.INTENT_DANGER;
    }
    else if (validationStatus === ItemStatus.PENDING) {
        colorClass = "";
    }
    return (React.createElement(Tooltip, { content: "Checking data integrity", position: Position.LEFT, usePortal: true, disabled: validationStatus !== ItemStatus.PENDING },
        React.createElement(Button, { type: "submit", disabled: !locked, className: `${Classes.BUTTON} ${iconClass(IconNames.FLOPPY_DISK)} ${colorClass} ${validationStatus === ItemStatus.PENDING
                ? Classes.DISABLED
                : statusClass} `, onClick: onSave, loading: validationStatus === ItemStatus.PENDING }, message)));
}
//# sourceMappingURL=SaveButton.js.map